import { Link } from "react-router-dom";
import { To } from "history";

// material-ui
import { SxProps } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";

// project imports
import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";
import { APP_DEFAULT_PATH } from "config";

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

export default function LogoSection({ reverse, isIcon, sx, to }: Props) {
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={to || APP_DEFAULT_PATH}
      sx={sx}
    >
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}
